import { render, staticRenderFns } from "./DistributionBarChart.vue?vue&type=template&id=4b9a5e50&scoped=true&"
import script from "./DistributionBarChart.vue?vue&type=script&lang=js&"
export * from "./DistributionBarChart.vue?vue&type=script&lang=js&"
import style0 from "./DistributionBarChart.vue?vue&type=style&index=0&id=4b9a5e50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9a5e50",
  null
  
)

export default component.exports